import { useSelector } from "react-redux";
import {
    makeSelectLiteTradeMarketDataBySymbol,
    makeSelectorGetLiteTradeAccountPositionInfo
} from "../../../../modules/LiteTrade/liteTradeSelectors";
import { LITE_TRADE_POSITION_SIDE } from "../../../../modules/LiteTrade/liteTradeConstants";
import amountFormat from "../../../../utils/amountFormat";
import classNames from "classnames";
import {
    SlideMobileModalInfoRowStyled
} from "./styled/SlideMobileStyled";
import type { IMobileAppRootState } from "../../../types/mobileAppState.t";
import type Asset from "../../../../modules/Asset/Asset";
import type {
    ILiteTradeAssetSymbol,
} from "../../../../modules/LiteTrade/types/liteTradeReducer.t";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import { useMemo } from "react";

interface ISlideMobilePositionModalProps {
    symbol: ILiteTradeAssetSymbol,
    positionCode: string,
    assetInstance: Asset,
}

const SlideMobilePositionModalMarket = (props: ISlideMobilePositionModalProps) => {
    const {
        symbol,
        positionCode,
        assetInstance,
    } = props;

    const { getLangPath } = useLangContext();
    const selectLiteTradeMarketDataBySymbol = useMemo(() => makeSelectLiteTradeMarketDataBySymbol(symbol), [symbol]);
    const selectorGetLiteTradeAccountPositionInfo = useMemo(() => makeSelectorGetLiteTradeAccountPositionInfo(positionCode), [positionCode]);
    const data = useSelector((state: IMobileAppRootState) => {
        const marketDataSymbol = selectLiteTradeMarketDataBySymbol(state);
        const positionInfo = selectorGetLiteTradeAccountPositionInfo(state);
        if (!positionInfo) {
            return null;
        }
        const side = positionInfo?.side !== LITE_TRADE_POSITION_SIDE.BUY ? 'ask' : 'bid';
        const currentPrice = marketDataSymbol?.[side] ?? 0;
        const pl = assetInstance.getPositionPL(positionInfo, currentPrice);
        const currentPriceFixed = assetInstance.amountToFixed(currentPrice);
        return {
            pl, 
            currentPriceFixed,
            side: positionInfo?.side
        }
    }, (left, right) =>
        left?.pl === right?.pl &&
        left?.currentPriceFixed === right?.currentPriceFixed &&
        left?.side === right?.side
    );
   
    if (!data) {
        return <>
            <div className="d-flex justify-content-center mt-4 align-items-center mb-4">
                <div className={"d-flex f28 fw600 wave-background "}>....</div>
            </div>
            <SlideMobileModalInfoRowStyled>
                <div className="label wave-background">.......</div>
                <div className="price f20 fw600  wave-background">.....</div>
            </SlideMobileModalInfoRowStyled>

        </>
    }

    return <>
            <div className="d-flex justify-content-center mt-4 align-items-center mb-4">
                <div className={classNames("d-flex f28 fw600", {
                    'positive': data.pl > 0,
                })}>
                    {data.pl !== null && amountFormat(data.pl, 2, '$', false, {
                        toFixed: true,
                    })}
                </div>
            </div>
            <SlideMobileModalInfoRowStyled>
                <div className="label">
                    {getLangPath(data?.side === LITE_TRADE_POSITION_SIDE.SELL
                        ? 'lite_version.order.current_price_spread'
                        : 'lite_version.order.current_price')}
                </div>
                <div className="price f20 fw600">{data.currentPriceFixed}</div>
            </SlideMobileModalInfoRowStyled>

        </>;
}


export default SlideMobilePositionModalMarket;
